export default __webpack_public_path__ + "static/media/english-to-russian-screenshot-05.f5e0b15a.png";